export { PageVisibleState } from './metric/base-metric';
export var BMEventsType = /*#__PURE__*/function (BMEventsType) {
  BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
  BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
  BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
  BMEventsType["CUSTOM"] = "CUSTOM";
  BMEventsType["WEB_VITALS"] = "WEB_VITALS";
  return BMEventsType;
}({});
export var StorableBMEventsType = /*#__PURE__*/function (StorableBMEventsType) {
  StorableBMEventsType["PAGE_LOAD"] = "page-load";
  StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
  StorableBMEventsType["INLINE_RESULT"] = "inline-result";
  StorableBMEventsType["CUSTOM"] = "custom";
  StorableBMEventsType["WEB_VITALS"] = "web-vitals";
  return StorableBMEventsType;
}({});
export var BMPageLoadMetrics = /*#__PURE__*/function (BMPageLoadMetrics) {
  BMPageLoadMetrics["fmp"] = "fmp";
  BMPageLoadMetrics["tti"] = "tti";
  return BMPageLoadMetrics;
}({});
export var BMPageSegmentLoadMetrics = /*#__PURE__*/function (BMPageSegmentLoadMetrics) {
  BMPageSegmentLoadMetrics["fmp"] = "fmp";
  BMPageSegmentLoadMetrics["tti"] = "tti";
  return BMPageSegmentLoadMetrics;
}({});
export var BMInteractionMetrics = /*#__PURE__*/function (BMInteractionMetrics) {
  BMInteractionMetrics["response"] = "response";
  BMInteractionMetrics["result"] = "result";
  return BMInteractionMetrics;
}({});
export var PageSegmentPageLoadMetricsOptions = /*#__PURE__*/function (PageSegmentPageLoadMetricsOptions) {
  PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
  PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
  PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
  return PageSegmentPageLoadMetricsOptions;
}({});
export var PageVisibleFields = /*#__PURE__*/function (PageVisibleFields) {
  PageVisibleFields["pageVisibleState"] = "page-visible-state";
  PageVisibleFields["pageVisibleValue"] = "page-visible-value";
  return PageVisibleFields;
}({});
export var PageVisibleValueOrigin = /*#__PURE__*/function (PageVisibleValueOrigin) {
  PageVisibleValueOrigin["documentHidden"] = "document-hidden";
  PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
  return PageVisibleValueOrigin;
}({});
export var isDetailedPageLoadSlo = function isDetailedPageLoadSlo(data) {
  return Boolean(data.initial);
};
export var isDetailedPageSegmentLoadSlo = function isDetailedPageSegmentLoadSlo(data) {
  return Boolean(data.initial);
};
export var isPageLoadMetricsSlo = function isPageLoadMetricsSlo(data) {
  var obj = data;
  return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
export var isInteractionMetricsSlo = function isInteractionMetricsSlo(data) {
  var obj = data;
  return Boolean(obj.result !== undefined || obj.response !== undefined);
};

// Only Used for PageSegmentLoad

export var IncludeSSRFeatureFlagsConfig = /*#__PURE__*/function (IncludeSSRFeatureFlagsConfig) {
  IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
  IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
  IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
  return IncludeSSRFeatureFlagsConfig;
}({});